// extracted by mini-css-extract-plugin
export default {"item":"RecycleItem_item__XuZTb","action":"RecycleItem_action__ZWQqP"};